var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9618_43651)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9618_43651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3447 16H3.65533C1.64322 16 0 14.3531 0 12.3447V3.65533C0 1.64695 1.64695 0 3.65533 0H12.3447C14.3568 0 16 1.64695 16 3.65533V12.3447C16 14.3568 14.3568 16 12.3447 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72186 5.8698C5.96172 5.8698 5.25728 6.0901 4.67887 6.4653V3.7018H3V12.2848H4.67887V11.8586C5.25728 12.2337 5.96172 12.4541 6.72186 12.4541C8.68869 12.4541 10.2831 10.9802 10.2831 9.162C10.2831 7.3438 8.68859 5.8698 6.72186 5.8698ZM6.56198 11.0162C5.48964 11.0162 4.62035 10.1854 4.62035 9.1606C4.62035 8.1358 5.48964 7.305 6.56198 7.305C7.63432 7.305 8.50361 8.1358 8.50361 9.1606C8.50361 10.1854 7.63432 11.0162 6.56198 11.0162ZM12.3285 3H13V13H12.3285V3Z",
    fill: "#03C75A",
    stroke: "#03C75A",
    strokeWidth: 0.01,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9618_43651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9618_43651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogMini);
export default __webpack_public_path__ + "static/media/blog_mini.f46c308dd92be7bce7f046c9dee4d5cb.svg";
export { ForwardRef as ReactComponent };